



































import CommonBase from "../CommonBase";
import {Component} from "vue-property-decorator";
import DeviceType from "../DeviceType.vue";
import IosWebviewButNotAppWarning from "@/components/shared/IosWebviewButNotAppWarning.vue";

@Component({
    components: {
        "at-devicetype": DeviceType,
        "at-ios-webview-not-app": IosWebviewButNotAppWarning,
    }
})
export default class QrInitInfo extends CommonBase {
    get browserWarning() {
        const ua = navigator.userAgent;
        if(ua.indexOf("CriOS/") >= 0) {
            return `QR kode registrering fungerer sannsynligvis ikke med denne nettleseren. Prøv med Safari istedenfor Chrome`;
        }
        const isApple = ua.indexOf("iPhone") > 0 || ua.indexOf("iPad") > 0 || ua.indexOf("Macintosh") > 0;
        const versionStart = ua.indexOf(" Version/");
        if(isApple) {
            if (versionStart > 0) {
                const majVersion = Number(ua.substr(versionStart + 9, 2));
                if (majVersion > 0 && majVersion < 11) {
                    return `Din Safari nettleser er utdatert. Du bør oppdatere den for at QR kode registrering skal fungere.`;
                }
            }
        }
        return null;
    }
}
